export function solutionSlider() {
    const $window = $(window);
    const $slider = $(".solutions-list.has-slider");
    $slider.each(function () {
        let $this = $(this);
        $window.on("load resize", function () {
            if ($window.innerWidth() >= 768) {
                if ($this.hasClass("slick-initialized")) {
                    $this.slick('refresh');
                    $this.slick('unslick');
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        infinite: false,
                        arrows: false,
                        dots: true,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 567,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    });
                }
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/solutionSlider.js